import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  Home,
  Login,
  Profile,
  SignUp,
  Transactions,
} from "../components/pages";

const router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>
    </BrowserRouter>
  );
};

export default router;
